<template>
  <div class="container-fluid">
    <b-row>
      <b-col
        sm="12"
        class="text-right my-1"
      >
      <locale />
      </b-col>
    </b-row>
    <b-row
      class="d-flex justify-content-center pt-1"
    >
      <b-col
        sm='12'
        class="text-center pb-1"
      >
      <!-- Brand logo-->
      <b-link :to="{name:'auth-login'}">
        <img class="img_logo" :src="logo" alt="logo">
      </b-link>
      <!-- /Brand logo-->
      </b-col>
    </b-row>
    <b-row class="mainrowtxt">
      <!-- Left Text-->
      <b-col
        lg="7"
        md="6"
        sm="12"
        class="d-lg-flex align-items-center p-2 p-lg-3 order-2 order-md-1"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-lg-5 p-md-0">
          <b-img
            class="forg_pass_img"
            fluid
            :src="imgUrl"
            alt="Forgot password"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Forgot password-->
      <b-col
        lg="5"
        md="6"
        sm="12"
        class="d-flex align-items-center auth-bg order-1 order-md-2"
      >
        <b-col
          cols="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title class="mb-1 fgtpass">
            {{$t('message.forgot_pass')}} 🔒
          </b-card-title>
          <b-card-text class="mb-2 entrmail">
            {{$t('message.enter_your_email')}}
          </b-card-text>

          <!-- form -->
          <validation-observer ref="simpleRules">
            <b-form
              class="auth-forgot-password-form mt-2"
              @submit.prevent="validationForm"
            >
              <b-form-group
                label="Email"
                label-for="forgot-password-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-input
                    id="forgot-password-email"
                    v-model="userEmail"
                    type="email"
                    required
                    :state="errors.length > 0 ? false:null"
                    name="forgot-password-email"
                    placeholder="john@example.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="btnLoading"
              >
                {{$t('message.reset_link')}}
              </b-button>
              <p v-if="error_sending_email" class="bg-danger text-white mt-1 p-1 rounded">
                {{$t('message.erroroccured')}}
              </p>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2 font-weight-bold">
            <b-link :to="{name:'auth-login'}">
              <feather-icon icon="ChevronLeftIcon" /> {{$t('message.back_login')}}
            </b-link>
          </p>
        </b-col>
      </b-col>
      <!-- /Forgot password-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import Locale from '../components/Locale.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BLink, BCardTitle, BCardText, BImg, BForm, BFormGroup, BFormInput, BButton,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BImg,
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    BCardTitle,
    BCardText,
    ValidationProvider,
    ValidationObserver,
    Locale
  },
  data() {
    return {
      error_sending_email: false,
      btnLoading: false,
      logo: require('@/assets/images/quotation/sft_logo.svg'),
      userEmail: '',
      sideImg: require('@/assets/images/pages/forgot-password-v2.svg'),
      // validation
      required,
      email,
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/forgot-password-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    toast(msg,variantMsg) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: msg,
          icon: 'EditIcon',
          variant: variantMsg,
        },
      })
    },
    validationForm() {
      this.btnLoading = true;
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          const data = {
            token:'1dbaa403b94ccdd1991c3afd511858a5',
            email:this.userEmail
          }
          const url= {
            prod: 'https://api-quote.safetravel.today/v2/app/reset_password_link'
          };
          fetch(url.prod, {
              method: 'post',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(data)
          })
          .then(response => {
            if (!response.ok) throw new Error(`HTTP reset password error ${response.status}`);
            return response.json();
          })
          .then((res)=> {
            if (res) {
              if (res === 'not_valid') {
                this.toast('No account found with that email address. Please check and try again.','danger')
              } else if(res==='link_already_sent') {
                this.toast('Please check your email. A link that has already been sent to reset your password is still active.','success');
              }
              else if (res==='email_sent') {
                this.userEmail='';
                this.toast('Please check your email. A link has been sent to reset your password.','success')
              }
            }
          })
          .catch(error => {
            console.warn('There was an error getting email link to reset password', error)
            this.error_sending_email = true;
          }) 
          .finally(() => {
            this.btnLoading = false;
          })
        } else {
          this.btnLoading = false; // reset if validation fails
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
.img_logo {
  display: inline-block;
  margin: 0 auto;
  max-width: 650px;
  width: 80%;
  height: auto;
}
.fgtpass {
  color: $green;
  font-weight: 700;
}
.entrmail {
  color: $gray-600;
  font-weight: 500;
}
label[for='forgot-password-email'] {
  color:$gray-600;
  font-weight: 600;
}
@media screen and (max-width: 992px) {
  .mainrowtxt {
    margin-top:25px;
  }
}
@media (max-width: 768px) {
  .forg_pass_img {
    display:block;
    margin:0 auto;
    max-width: 60%;
  }
}
@media (max-width: 564px) {
  .forg_pass_img {
    max-width: 80%;
  }
}
</style>
